<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'

	export type FooterLinkContext = {
		url?: string

		label: string
		iconName?: string
		disabled?: boolean
		target?: '_blank' | '_self' | ''
		callback?: () => void
	}[]

	export type FooterContext = {
		key?: string
		title?: string
		open?: boolean
		links: FooterLinkContext
		disabled?: boolean
		displayOnlyOnMobile?: boolean
	}
	const { linkList } = defineProps<{
		linkList: FooterContext[]
		titleWrapperCls?: ClassNameValue
		titleCls?: ClassNameValue
		liCls?: ClassNameValue
		btnCls?: ClassNameValue
		keyId?: string
	}>()
	const list = ref<FooterContext[]>([])
	const { isMobile } = useMobile()
	defineEmits<{
		(e: 'onLinkClick', link?: string): void
	}>()
	onMounted(() => {
		list.value = linkList
	})
</script>

<template>
	<ul class="md:flex items-start xl:justify-between flex-wrap gap-y-5 md:gap-x-[133px] xl:flex-nowrap">
		<template v-for="(link, index) in linkList" :key="index">
			<li
				v-if="!link.disabled"
				:class="
					cn(
						link.displayOnlyOnMobile ? 'md:hidden' : '',
						'py-5 md:py-0 border-b md:border-none border-gray-700',
						titleWrapperCls
					)
				"
			>
				<button
					type="button"
					class="inline-flex w-full md:w-auto text-left gap-6 outline-none items-center justify-between"
					:aria-label="link.title"
					@click="() => isMobile && (link.open = !link.open)"
				>
					<h3 :class="cn('text-base text-white font-[700]', titleCls)">{{ link.title }}</h3>
					<span :class="cn(link.open ? '-rotate-180' : 'rotate-0', 'transition-all ease-linear', btnCls)">
						<slot name="btn-icon" :is-open="link.open">
							<tools-icon dir="arrows" icon="caret-down" svg-class="md:hidden" />
						</slot>
					</span>
				</button>

				<div
					class="md:!max-h-full md:overflow-visible overflow-hidden overflow-y-auto custom-transition-2 flex-col"
					:style="{ maxHeight: link.open || (keyId && link.key === keyId) ? '1300px' : '0' }"
				>
					<div v-for="(item, index) in link.links" :key="item.label + index">
						<span
							v-if="!item?.disabled"
							:class="[
								{
									'cursor-pointer': item?.callback
								},
								cn(
									'pt-4 text-gray-400 text-sm max-w-[205px] hover:text-base-primary transition-colors ease-linear font-normal underline-2 inline-flex',
									liCls
								)
							]"
						>
							<nuxt-link
								v-if="item?.url"
								:to="item?.url ?? ''"
								:target="item.target"
								:aria-label="item.label"
								:external="Boolean(item.target == '_blank')"
							>
								{{ item.label }}
							</nuxt-link>
							<button
								v-else
								class="cursor-pointer text-left"
								type="button"
								@click="() => [item?.callback && item?.callback(), $emit('onLinkClick', item.label)]"
							>
								{{ item.label }}
							</button>
						</span>
						<br />
					</div>
				</div>
			</li>
		</template>
	</ul>
</template>
